import type { TableTranslation } from './table-pl';

export const tableDe = {
  of: 'von',
  reset: 'Zurücksetzen',
  searchPlaceholder: 'Suchen...',
  savedViews: 'Gespeicherte Ansichten',
  saveView: 'Ansicht speichern',
  saveInfo: 'Die folgenden Einstellungen werden gespeichert: Tabelleneinstellungen und angewendete Filter.',
  name: 'Name',
  namePlaceholder: 'z.B. Kundenaufträge',
  description: 'Beschreibung',
  descriptionPlaceholder: 'Beschreiben Sie kurz, wie die Ansicht funktioniert',
  setAsDefaultView: 'Als Standardansicht festlegen',
  save: 'Speichern',
  cancel: 'Abbrechen',
  default: 'Standard',
  delete: 'Löschen',
  noSavedViews: 'Es gibt noch keine gespeicherten Ansichten',
  noData: 'Keine Daten',
  columnsOrder: 'Spaltenreihenfolge',
  columnsOrderSettings: 'Spaltenreihenfolge Einstellungen',
  columnsOrderInfo:
    'Ziehen Sie, um die Reihenfolge der Spalten zu ändern. Ausblenden (Auge) oder Fixieren (Pin) ausgewählte Elemente. Fixierte Spalten sind immer auf der linken Seite der Tabelle sichtbar.',
  columnsOrderInfoBanner: 'Einstellung wird den gespeicherten Ansichten zugewiesen.',
  overrideCurrentView: 'Aktuelle Ansicht überschreiben',
  overrideCurrentViewModalHeader: 'Aktuelle Ansicht überschreiben?',
  overrideCurrentViewModalDescription:
    'Die Tabelleneinstellungen wurden geändert. Möchten Sie die Ansicht <strong>{{name}}</strong> mit der aktuellen Ansicht überschreiben?',
  override: 'Überschreiben',
  saveAsNewView: 'Als neue Ansicht speichern',
  noSearchResults: 'Keine Ergebnisse. Ändern Sie die Suchkriterien.',
  moreOptions: 'Mehr Optionen',
  advancedFilters: 'Erweiterte Filter',
  exportToCsv: 'CSV herunterladen',
  csvExportStarted: 'CSV-Download gestartet',
  csvExportSuccess: 'CSV-Datei wurde erfolgreich heruntergeladen',
  csvExportError: 'Fehler beim Herunterladen der CSV-Datei',
} satisfies TableTranslation;
